import { ImageWithCustomLoader } from '@components/image-with-custom-loader'
import React from 'react'
import { exhibitionTransition } from './header'
import { motion } from 'motion/react'
import { DetailText } from 'design-configuration/components'
import { useSoloViewer } from '@components/solo-viewer/provider'

type ThreeImageRowProps = {
  items: {
    imageUrl: string
    caption?: string
  }[]
}
export const ThreeImageRow = ({ items }: ThreeImageRowProps): React.ReactElement => {
  const { setSoloViewerImageData } = useSoloViewer()
  const imageList = items.map((item) => item.imageUrl)
  return (
    <div className="lg:gap-xs gap-sm relative grid w-full grid-cols-3">
      {items.map((item, index) => (
        <div key={`three-image-row-${index}-${item.imageUrl}`} className="flex flex-col">
          <motion.button
            className="relative col-span-1 aspect-[3/2]"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={exhibitionTransition}
            viewport={{ once: true, amount: 0.5 }}
            onClick={() => {
              setSoloViewerImageData({ image: item.imageUrl, imageList: imageList })
            }}
          >
            <ImageWithCustomLoader
              src={item.imageUrl}
              alt={`Three image row ${index} ${item.caption}`}
              style={{
                objectFit: 'cover'
              }}
              fill
              sizes="(max-width: 1080px) 33vw, 100vw"
            />
          </motion.button>
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={exhibitionTransition}
            viewport={{ once: true, amount: 0.3 }}
          >
            {item.caption ? (
              <DetailText className="px-md pt-xs text-on-surface-variant">{item.caption}</DetailText>
            ) : null}
          </motion.div>
        </div>
      ))}
    </div>
  )
}
